module.exports = __webpack_public_path__ + "static/high_voltage2-dd8f818bf28517c89b0d04b9fac8da2a.png";